import React, { useState } from "react";
import CoverPhotoBaseURL from "../../../../util/coverPhotoBaseURL";
import "./style.css";

const OfferBook = ({ item, isSelected, handleBookSelection }) => {
  console.log(item);
  return (
    <div className="offer-book-col" onClick={() => handleBookSelection(item)}>
      <div className="imgcontainer2" role="button">
        <img
          src={`${CoverPhotoBaseURL}${item?.library?.coverimage}`}
          alt="offer-book-img3"
          className={`${isSelected ? "offer-book-img2" : "offer-book-img"}`}
        />
        <div
          className={`${
            isSelected ? "offer-book-check-box2" : "offer-book-check-box"
          }`}
        >
          <img
            src={require("../../../../../assets/icons/white-tick.svg").default}
          />
        </div>
      </div>
      <div className="recent-activity-text">
        <div className="d-flex flex-column">
          <span>${item?.library?.price}</span>
        </div>
      </div>
    </div>
  );
};

export default OfferBook;
